import { DETALLE_INSCRIPCION_URL } from '../config';

import axios from 'axios';

export const getDetalleInscripcion = async (params) => {
    const { codigo, documento } = params;
    const url = `${DETALLE_INSCRIPCION_URL}?codigo=${codigo ? codigo : ""}&nroDocumento=${documento ? documento : ""}`;
    const result = await axios.get(url);
    return result.data;
}

/*const result = [
        //CABECERA
        { nombre: "Mario", apellido: "Lopez", dni: "45667098", nivel: "Secundario" },
        //RESPONSABLES
        [
            { nombre: "Mario", apellido: "Lopez", dni: "32564889", tipo: "Principal", vinculo: "Padre", principal: true },
            { nombre: "Jose", apellido: "Lopez", dni: "45667098", tipo: "Secundario", vinculo: "Tutor", principal: false },
            { nombre: "Laura", apellido: "Sanchez", dni: "35662146", tipo: "Secundario", vinculo: "Madre", principal: false },
        ],
        //ESTABLECIMIENTOS SELECCIONADOS
        [
            { id: 1, nombre: "Comercio", direccion: "Costanera 123", turno: "Mañana", hermano: true, familiar: false, inscAsociada: true, estado: true },
            { id: 2, nombre: "Regional", direccion: "Regional 123", turno: "Tarde", hermano: false, familiar: true, inscAsociada: false, estado: true },
            { id: 3, nombre: "Normal", direccion: "Normal 123", turno: "Mañana", hermano: false, familiar: false, inscAsociada: false, estado: false },
        ],
        //SORTEO
        [
            //PROPONER ESTABLECER PRIORIDDAD MEDIANTE BANDERA Y SI FUE A ESTATAL
            //BANDERA = 2
            //ESTATAL = 1
            //ESTATAL Y BANDERA = 3
            //NINGUNO = 0
            { establecimientoId: 1, bandera: true, estatal: true, nroOrden: 45 },
            { establecimientoId: 2, bandera: true, estatal: true, nroOrden: 50 },
            { establecimientoId: 3, bandera: true, estatal: true, nroOrden: 16 },
        ],
        //RESULTADOS
        [
            { establecimientoId: 1, estado: "Obutvo el lugar", nroOrden: 45 },
            { establecimientoId: 2, estado: "Sin lugar", nroOrden: 50 },
            { establecimientoId: 3, estado: "Sin lugar", nroOrden: 16 },
        ]
    ]*/